import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom';
import Sidebar from './Sidebar'
import { country_code_array } from '../functions';
import { Helmet } from 'react-helmet';
import BACKEND_URL from '../../../api';
import '../../../My_Account.css'

export default function Settings() {
    const userid = sessionStorage.getItem('userid')

    const [isOpen, setIsOpen] = useState(false);
    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };
    const [countries, setcountries] = useState(country_code_array);
    const [collectionDetails, setcollectionDetails] = useState({
        country: 'AE',
        user_email: '',
        display_name: '',
        phone: ''

    })
    const [personaldetails, setpersonaldetails] = useState({
        user_email: '',
        display_name: '',
        phone: ''
    })
    const [active, setactive] = useState('personal')
    const [errormsg, seterrormsg] = useState('')
    const [errorcount, seterrorcount] = useState(0)
    const [updatemsg, setupdatemsg] = useState()
    function setactivefun(val) {
        if (active == val) {
            setactive('')
        } else {
            setactive(val)
        }

    }

    useEffect(() => {
        fetch(`${BACKEND_URL}/getPersonalDetails`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                userid: userid,
                type: "getdata"
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                console.log(data);
                setcollectionDetails({
                    ...collectionDetails,
                    display_name: data.details.display_name,
                    user_email: data.details.user_email,
                    phone: data.details.phone,
                    user_pass: data.details.user_pass,
                });
            })
            .catch(err => console.log(err));
    }, [])

    function checkpassword(newpass) {
        if (collectionDetails.user_pass != newpass) {

            seterrormsg('Incorrect email or password. Please try again.')
            seterrorcount(1);
        } else {

            seterrormsg('')
            seterrorcount(0);
            setcollectionDetails({ ...collectionDetails, confirmpass: newpass })
        }

    }


    function submitDetails() {
        if (errorcount == 1) {
            //console.log(errormsg)
            console.log('unable to process')
        } else {
            fetch(`${BACKEND_URL}/getPersonalDetails`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    userid: userid,
                    collectionDetails: collectionDetails,
                    type: "update"
                }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json(); // Use response.text() since you're checking for a string
                })
                .then((data) => {
                    console.log("getPersonalDetails--------", data)
                    if (data.msg === 'updated') {
                        setupdatemsg('Details updated successfully!');
                    }
                })
                .catch(err => console.log(err));
        }

    }

    return (
        <div className="my_parcels">
            <Helmet>
                <title>Shypv | Settings</title>
            </Helmet>
            <div className="myparctab" style={{ padding: "0" }}>

                <div className="container-fluid" style={{ padding: "0" }}>
                    <div className="row1">

                        <Sidebar isOpen={isOpen} />

                        {/* /#admin-sidebar */}
                        <div id="admin-main-control" className="col-md-9 p-x-3 p-y-1" style={{ overflow: "auto", backgroundColor: "#f1f5f9" }}>
                            <div style={{ boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)" }}>
                                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                                    <div className="container-fluid" style={{ justifyContent: "space-between" }}>
                                        <button className="navbar-toggler" type="button" onClick={toggleSidebar}>
                                            {
                                                isOpen ? (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="32"
                                                        height="32"
                                                        className="bi bi-arrow-bar-left"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"
                                                        />
                                                    </svg>
                                                ) : (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="32"
                                                        height="32"
                                                        className="bi bi-arrow-bar-right"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5"
                                                        />
                                                    </svg>
                                                )
                                            }
                                        </button>
                                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="offset-1 collapse navbar-collapse" id="navbarNav">
                                            <ul className="navbar-nav">
                                                <>
                                                    <li className="nav-item">
                                                        <NavLink activeclassname="active" exact to="/">HOME</NavLink>
                                                        {/* <Link className="nav-link active"  aria-current="page" exact  to="/">HOME  </Link> */}
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink exact to="/track">TRACK</NavLink>
                                                        {/* <Link className="nav-link" exact  to="/track">TRACK</Link> */}
                                                    </li>

                                                    {/* <li className="nav-item">
                                                            <NavLink exact to="/smart-send">SMART SEND</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/your-business">YOUR BUSINESS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/help">HELP</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/become-a-partner">PARTNERS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/parcels-on-demand">HOW IT WORKS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="https://www.tymexlogistics.com/" target="_blank">LOGISTICS</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/client-zone">CLIENT ZONE</NavLink>
                                                        </li> */}
                                                </>
                                            </ul>
                                        </div>
                                    </div>
                                </nav>
                            </div>

                            <div style={{ margin: "20px", padding: "20px", backgroundColor: "white", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)" }}>
                                <h3>MY DETAILS</h3>
                                <div className="col-md-12 col-sm-12 col-xs-12" style={{ border: "1px solid #c3bbbb", marginTop: "2%", borderRadius: "6px" }}>
                                    <h3 onClick={() => setactivefun('personal')} className="panel-title comaprison_hedding" style={{ padding: "2%", background: "#f5f5f5" }}>Personal Details</h3>

                                    {active == 'personal' ? (
                                        <>


                                            <div className="row" style={{ padding: "3%" }}>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="exampleInputEmail1">Full Name<span className="required">*</span></label>
                                                        <input type="text" className="form-control" value={collectionDetails.display_name} name="collection_name" onChange={(e) => setcollectionDetails({ ...collectionDetails, display_name: e.target.value })} id="collection_name" maxLength={50} />
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="exampleInputEmail1">Phone<span className="required">*</span></label>
                                                        <input type="text" value={collectionDetails.phone} className="form-control" name="collection_phone" id="collection_phone" onChange={(e) => setcollectionDetails({ ...collectionDetails, phone: e.target.value })} placeholder="Phone" style={{ margin: 0 }} />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="exampleInputEmail1">Email<span className="required">*</span></label>
                                                        <input type="text" className="form-control" value={collectionDetails.user_email} name="collection_email" onChange={(e) => setcollectionDetails({ ...collectionDetails, user_email: e.target.value })} id="collection_email" placeholder="Email" />
                                                    </div>
                                                </div>

                                            </div>




                                        </>
                                    ) : null}

                                </div>

                                <div className="col-md-12 col-sm-12 col-xs-12" style={{ border: "1px solid #c3bbbb", marginTop: "2%", borderRadius: "6px" }}>
                                    <h3 onClick={() => setactivefun('password')} className="panel-title comaprison_hedding" style={{ padding: "2%", background: "#f5f5f5" }}>Change Password</h3>
                                    {active == 'password' ? (
                                        <>
                                            <form>
                                                <div className="row" style={{ padding: "3%" }}>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">New Password</label>
                                                            <input type="password" className="form-control" name="collection_address" onChange={(e) => setcollectionDetails({ ...collectionDetails, user_pass: e.target.value })} id="collection_address" placeholder="Password" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12" style={{ marginTop: "2%" }}>
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Confirm New Password</label>
                                                            <input type="password" className="form-control" name="collection_address" onChange={(e) => checkpassword(e.target.value)} id="collection_address" placeholder="Confirm New Password" />
                                                        </div>
                                                        <p style={{ color: "red" }}>{errormsg}</p>
                                                    </div>
                                                </div>
                                            </form>
                                        </>
                                    ) : null}
                                </div>

                                <div className="col-md-12 col-sm-12 text-right" style={{ display: "flex", justifyContent: "right" }}>
                                    <input type="button" defaultValue="Submit" onClick={submitDetails} name="save" className="btn btn-success pull-right" id="save" style={{ float: "right", margin: "3%", backgroundColor: "#3c50e1" }} />
                                </div>
                                <p style={{ color: "green", fontWeight: "500" }}>{updatemsg}</p>

                                <div onClick={() => setactivefun('address')} className="col-md-12 col-sm-12 col-xs-12" style={{ display: "none", border: "1px solid #c3bbbb", marginTop: "2%", borderRadius: "6px" }}>
                                    <h3 className="panel-title comaprison_hedding" style={{ padding: "2%", background: "#f5f5f5" }}>Address Information</h3>

                                    {active == 'address' ? (
                                        <>


                                            <form>
                                                <div className="row" style={{ marginLeft: "15px", marginRight: "15px" }}>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Address</label>
                                                            <input type="text" className="form-control" name="collection_address" onChange={(e) => setcollectionDetails({ ...collectionDetails, address: e.target.value })} id="collection_address" placeholder="Address" />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-8">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">City/Town</label>
                                                                    <input type="text" className="form-control" name="collection_city" onChange={(e) => setcollectionDetails({ ...collectionDetails, city: e.target.value })} id="collection_city" placeholder="City/Town" />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-5">
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">Country<span className="required">*</span></label>

                                                                    <select className="form-select select-export-package" name="delivery_to" onChange={(e) => setcollectionDetails({ ...collectionDetails, country: e.target.value })}>
                                                                        {

                                                                            Object.entries(countries).map(([k, v]) => (
                                                                                <option key={k} value={k} >{v}</option>
                                                                            ))
                                                                        }

                                                                    </select>

                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">Zipcode</label>
                                                                    <input type="text" className="form-control cd" name="collection_zipcode" onChange={(e) => setcollectionDetails({ ...collectionDetails, zipcode: e.target.value })} id="collection_zipcode" placeholder="Zipcode" />
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 col-sm-12 text-right" >
                                                        <input type="button" defaultValue="Submit" name="save" className="btn btn-success pull-right" id="save" style={{ float: "right", margin: "3%" }} />
                                                    </div>
                                                </div>
                                            </form>
                                        </>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
